import { Component } from "preact";
// eslint-disable-next-line no-unused-vars
import PropTypes from "prop-types";
import { combineClasses } from "@green24/npm-javascript-utils";
import Fa from "../Fa";
import Interpret from "../Localization/Interpret";
import ButtonsConstructor from "../Input/Button/ButtonsConstructor";
import { M_Icons } from "../../../models/Models_Icons";
import { ComponentUtils } from "@green24/npm-preact-utils";
import { withModalContext } from "../../components";

class MessageModal extends Component {
	render({className, style, icon, iconProps, title, titleTranslated, message, messageTranslated, actionButtons, modalContext, titleProps, messageProps}) {
		const defaultActionButtons = [
			{
				text: "close",
				className: "close",
				action: () => modalContext.close(),
			}
		]
		const __resolveAsString = s => (
			<p>
				{messageTranslated ? s :
					<Interpret id={s} {...messageProps}/>}
			</p>
		);

		return (
			<section className={combineClasses("message-modal", className)} style={style}>
				<h1>
					{
						icon &&
						<Fa icon={icon} {...iconProps}/>
					}
					{
						title &&
						(
							titleTranslated &&
							title
							||
							<Interpret id={title} {...titleProps}/>
						)
					}
				</h1>

				{
					message &&
					ComponentUtils.resolvePolymorphProp(
						message,
						{
							string: __resolveAsString,
							number: __resolveAsString,
							function: f => f(),
						},
						message,
					)
				}

				<nav className={"action-buttons"}>
					<ButtonsConstructor
						buttons={ComponentUtils.resolvePolymorphProp(
							actionButtons,
							{
								component: c => [c],
								function: f => f(defaultActionButtons),
								array: arr => [...defaultActionButtons, ...arr],
								boolean: b => b ? defaultActionButtons : [],
							},
							defaultActionButtons
						)}
						sharedProps={{elevation: true, accent: "primary"}}
					/>
				</nav>
			</section>
		);
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			icon: PropTypes.oneOf(Object.keys(M_Icons)),
			iconProps: PropTypes.object,
			title: PropTypes.string,
			titleTranslated: PropTypes.bool,
			titleProps: PropTypes.object,
			message: PropTypes.any,
			messageTranslated: PropTypes.bool,
			messageProps: PropTypes.object,
			actionButtons: PropTypes.oneOfType([PropTypes.bool, PropTypes.element, PropTypes.func, PropTypes.array]),
		}
	}

	static get defaultProps() {
		return {
			titleTranslated: false,
			messageTranslated: false,
			actionButtons: [],
			titleProps: {},
			messageProps: {},
			iconProps: {},
		}
	}
}

export default withModalContext(MessageModal);
